import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'contact',
    templateUrl: 'contact.html'
})
export class Contact implements OnInit {
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/pages/contact/contact.ts